import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(site)/(main)/richtlijnen/GuidelinesPage.tsx");
